import { Illustration, Span, Text, Title } from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

interface ScanInstructionsProps {
  kioskLocation: string;
  onContinue: () => void;
  onCancel: () => void;
}

export function ScanInstructions(props: ScanInstructionsProps) {
  const { kioskLocation, onContinue, onCancel } = props;

  return (
    <>
      <DialogContent sx={{ paddingX: 5, paddingTop: 8, textAlign: "center" }}>
        <Stack spacing={4} alignItems="center">
          <Title semibold variant="h3" component="h3">
            TouchPoint Kiosk
          </Title>
          <Illustration type="location" />
          <Text variant="body1" color={(theme) => theme.palette.text.secondary}>
            You&apos;ll need to scan a QR code at the TouchPoint kiosk located at{" "}
            <Span style={{ fontWeight: "500" }}>{kioskLocation}</Span>.
          </Text>
          <Text variant="body1">Make sure you have access to the kiosk before proceeding.</Text>
        </Stack>
      </DialogContent>
      <DialogFooter orientation="vertical" closeButtonAriaLabel="Cancel" onClose={onCancel}>
        <Button fullWidth size="large" variant="contained" onClick={onContinue}>
          I&apos;m ready
        </Button>
      </DialogFooter>
    </>
  );
}
